/**
 * Redux actions for OTA updates
 */

import { IUpdateManifest, IUpdateComponent, IUpdateProgress } from '../../models/Update';

// Action Types
export const CHECK_UPDATES_REQUEST = 'CHECK_UPDATES_REQUEST';
export const CHECK_UPDATES_SUCCESS = 'CHECK_UPDATES_SUCCESS';
export const CHECK_UPDATES_FAILURE = 'CHECK_UPDATES_FAILURE';

export const DOWNLOAD_UPDATE_REQUEST = 'DOWNLOAD_UPDATE_REQUEST';
export const DOWNLOAD_UPDATE_PROGRESS = 'DOWNLOAD_UPDATE_PROGRESS';
export const DOWNLOAD_UPDATE_SUCCESS = 'DOWNLOAD_UPDATE_SUCCESS';
export const DOWNLOAD_UPDATE_FAILURE = 'DOWNLOAD_UPDATE_FAILURE';

export const CANCEL_DOWNLOAD_REQUEST = 'CANCEL_DOWNLOAD_REQUEST';

export const APPLY_UPDATES_REQUEST = 'APPLY_UPDATES_REQUEST';
export const APPLY_UPDATES_SUCCESS = 'APPLY_UPDATES_SUCCESS';
export const APPLY_UPDATES_FAILURE = 'APPLY_UPDATES_FAILURE';

export const DISMISS_UPDATE = 'DISMISS_UPDATE';
export const RESET_UPDATE_STATE = 'RESET_UPDATE_STATE';
export const SET_CURRENT_VERSION = 'SET_CURRENT_VERSION';

// Action Creators
export const checkUpdates = {
  request: () => ({ type: CHECK_UPDATES_REQUEST }),
  success: (manifest: IUpdateManifest, availableUpdates: IUpdateComponent[]) => ({
    type: CHECK_UPDATES_SUCCESS,
    payload: { manifest, availableUpdates },
  }),
  failure: (error: string) => ({
    type: CHECK_UPDATES_FAILURE,
    payload: { error },
  }),
};

export const downloadUpdate = {
  request: (update: IUpdateComponent) => ({
    type: DOWNLOAD_UPDATE_REQUEST,
    payload: { update },
  }),
  progress: (progress: IUpdateProgress) => ({
    type: DOWNLOAD_UPDATE_PROGRESS,
    payload: { progress },
  }),
  success: (update: IUpdateComponent, downloadedPath: string) => ({
    type: DOWNLOAD_UPDATE_SUCCESS,
    payload: { update, downloadedPath },
  }),
  failure: (update: IUpdateComponent, error: string) => ({
    type: DOWNLOAD_UPDATE_FAILURE,
    payload: { update, error },
  }),
};

export const cancelDownload = (updateType: string, version: string) => ({
  type: CANCEL_DOWNLOAD_REQUEST,
  payload: { updateType, version },
});

export const applyUpdates = {
  request: () => ({ type: APPLY_UPDATES_REQUEST }),
  success: () => ({ type: APPLY_UPDATES_SUCCESS }),
  failure: (error: string) => ({
    type: APPLY_UPDATES_FAILURE,
    payload: { error },
  }),
};

export const dismissUpdate = (updateType: string) => ({
  type: DISMISS_UPDATE,
  payload: { updateType },
});

export const resetUpdateState = () => ({
  type: RESET_UPDATE_STATE,
});

export const setCurrentVersion = (version: string) => ({
  type: SET_CURRENT_VERSION,
  payload: { version },
});
